import React, { useState } from 'react'
import { Flex, Grid, Stack } from '@mantine/core'
import JobList from '../components/JobList'
import JobFilters from '../components/JobFilters'

const WIDTH = { base: '90%', md: '80%', lg: '60%' }
const MAX_WIDTH = '1170px'
const JOB_POSTING_COLS = { base: 12, md: 12, lg: 12 }

/**
 * Renders the HireScore job board homepage.
 * @returns {JSX.Element}
 */
export default function JobsHome () {
  const [filters, setFilters] = useState({ keywords: [], job_categories: [], job_types: [] })

  return (
    <Flex
      gap='md'
      justify='center'
      align='center'
      direction='column'
      wrap='wrap'
      h='100%'
      pb='5em'
    >
      <Grid w={WIDTH} maw={MAX_WIDTH} mt='9.5vh'>
        <Grid.Col span={JOB_POSTING_COLS}>
          <Stack>
            <JobFilters filters={filters} setFilters={setFilters} />
            <JobList filters={filters} />
          </Stack>
        </Grid.Col>
      </Grid>
    </Flex>
  )
}
